import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

if (environment.sentry.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: environment.releaseVersion,
    integrations: [
      Sentry.browserSessionIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Optional privacy settings:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracePropagationTargets: environment.sentry.tracingOrigins,
    ignoreSpans: [
      { name: /^Zone(:.*)?$/ },
      // { name: /app\.productfruits\.com/ },
      { name: /wilsonapp\.matomo\.cloud/ },
      // { name: /events\.launchdarkly\.com/ },
      // { name: /app\.launchdarkly\.com/ },
      { name: /cdn\.talkjs\.com/ },
      // { name: /maps\.googleapis\.com/ },
      { name: /mark_feature_usage/ },
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
  });
}

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
